var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetaBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 24,
    viewBox: "0 0 56 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 24,
    rx: 9,
    fill: "#ACDAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.03 11.812C15.6873 12.0273 16.2087 12.39 16.594 12.9C16.9793 13.3987 17.172 14.022 17.172 14.77C17.172 15.8013 16.7753 16.6003 15.982 17.167C15.1887 17.7223 14.0327 18 12.514 18H6.598V6.1H12.174C13.5793 6.1 14.6617 6.37767 15.421 6.933C16.1803 7.477 16.56 8.23067 16.56 9.194C16.56 9.78333 16.424 10.3047 16.152 10.758C15.88 11.2113 15.506 11.5627 15.03 11.812ZM8.808 7.834V11.115H11.936C12.7067 11.115 13.296 10.979 13.704 10.707C14.1233 10.4237 14.333 10.0157 14.333 9.483C14.333 8.939 14.1233 8.531 13.704 8.259C13.296 7.97567 12.7067 7.834 11.936 7.834H8.808ZM12.378 16.266C14.0893 16.266 14.945 15.6937 14.945 14.549C14.945 13.4043 14.0893 12.832 12.378 12.832H8.808V16.266H12.378ZM28.4556 16.147V18H19.5306V6.1H28.2176V7.953H21.7406V11.047H27.4866V12.866H21.7406V16.147H28.4556ZM33.3333 7.97H29.3893V6.1H39.4873V7.97H35.5433V18H33.3333V7.97ZM48.2662 15.246H42.3162L41.1432 18H38.8652L44.2202 6.1H46.3962L51.7682 18H49.4562L48.2662 15.246ZM47.5352 13.512L45.2912 8.31L43.0642 13.512H47.5352Z",
    fill: "#2588F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetaBig);
export default __webpack_public_path__ + "static/media/beta_big.1822d250b17fbe906df07a46d234d01b.svg";
export { ForwardRef as ReactComponent };